// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__VMQOs","layout_left":"style_layout_left__GB1VK","layout_right":"style_layout_right__6np3q","buttons":"style_buttons__KkE+E"};